import { HTMLButtonElement, html } from '@html-element-wrappers/button';
import { enableFocusVisible } from '../utils/focus-visible-polyfill.js';
import { css } from './button.css.js';
import { StyleResizeObserverMixin } from '../utils/style-resize-observer-mixin';

/**
 * 
 * @element slicesui-button
 * 
 * @fires click
 * 
 * @prop {Boolean} [disabled=false] - If `true`, button cannot be clicked
 * @attr {Boolean} disabled
 * 
 * @cssprop --slicesui-button-border-radius - Border Radius
 * @cssprop --slicesui-button-background - Background
 * @cssprop --slicesui-button-color - Text Color
 * 
 * @slot - Label goes here
 * 
 */

class SlicesUIButton extends StyleResizeObserverMixin(HTMLButtonElement) {

  get styles() {
    return html`<style>${css}</style>`;
  }

  constructor() {
    super();
    enableFocusVisible(this);
    this.observeAndSetStyles();
  }
  
}

window.customElements.define('slicesui-button', SlicesUIButton);